import classNames from 'classnames'
import { useEffect, useState } from 'react'

import { checkTypeRecur } from './helpers/checkTypeRecur'
import { getArray } from './helpers/getArray'
import { IGridProps } from './models/IGrid'

import styles from './Grid.module.scss'

export const Grid = ({
  className,
  children,
  gap,
  noGap,
  noRootMargin,
  direction,
  bottomMargin,
  wrap,
  justify,
  alignItems,
}: IGridProps) => {
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    const IterableChildren = getArray(children)
    let resultError: boolean = false

    IterableChildren.forEach((item: any) => {
      if (checkTypeRecur(item)) {
        resultError = true
      }
    })

    setError(resultError)
  }, [])

  if (error) {
    return (
      <div className={styles.error}>
        Anything except &lt;Item&gt; element is not allowed in the &lt;Grid&gt;!
      </div>
    )
  }
  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles[`root--gap-${gap}`]]: gap,
          [styles['root--noGap']]: noGap,
          [styles['root--noRootMargin']]: noRootMargin,
          [styles[`bottomMargin-${bottomMargin}`]]: bottomMargin,
          [styles[`direction-${direction}`]]: direction,
          [styles[`wrap-${wrap}`]]: wrap,
          [styles[`justify-${justify}`]]: justify,
          [styles[`alignItems-${alignItems}`]]: alignItems,
        },
        className || ''
      )}
    >
      {children}
    </div>
  )
}
